import { render, staticRenderFns } from "./CreateExpense.vue?vue&type=template&id=f04a433e&"
import script from "./CreateExpense.vue?vue&type=script&lang=js&"
export * from "./CreateExpense.vue?vue&type=script&lang=js&"
import style0 from "./CreateExpense.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports